// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3JR0F","list":"PatternAutocomplete_list__3B0-P"};